module.exports = __webpack_public_path__ + "img/default_placeholder.b9c29d5.jpg";